module.exports = __webpack_public_path__ + "img/u194_div.67c66f05.png";